(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedRouteDeleteController',MedRouteDeleteController);

    MedRouteDeleteController.$inject = ['$uibModalInstance', 'entity', 'MedRoute'];

    function MedRouteDeleteController($uibModalInstance, entity, MedRoute) {
        var vm = this;

        vm.medRoute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MedRoute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
